// extracted by mini-css-extract-plugin
module.exports = {"piePagina":"Footer_piePagina__2At_m"};